<template>
  <div>
    <h4 class="title">{{ $t('common.welcome') }}</h4>
    <h1 class="title">S/. {{ accountBalance }}</h1>
    <van-cell-group inset>
      <van-cell :title="$t('user.capitalFlow')" :value="$t('common.see')" is-link @click="showFlow" />
      <van-cell :title="$t('user.rechargeApply')" :value="recharge.deses" :is-link="!(applyedRechargeAmount>0)" @click="showRecharge" />
    </van-cell-group>

    <van-cell-group inset style="margin-top:50px">
      <van-cell :title="$t('user.ourContactInfo')" />
      <van-cell :title="$t('user.phone')" :value="$t('user.call')" is-link @click="call" />
      <van-cell title="WhatsApp" :value="$t('user.contact')" is-link @click="openWhatsapp" />
    </van-cell-group>

    <van-button type="primary" block size="small" @click="showChangePassword" class="bottom-btn">{{ $t('account.changePassword') }}</van-button>
    <van-button type="danger" block size="small" @click="logout" class="bottom-btn">{{ $t('account.logout') }}</van-button>

    <van-popup position="bottom" closeable round v-model="flowShow">
      <div class="prop-content">
        <h4>{{ $t('user.capitalFlow') }}</h4>
        <div v-for="item in flowItems" :key="item.id">
          <van-cell :title="item.timeAdd" :value="item.amount" />
          <div class="flow-remark">{{ item.remark }}</div>
        </div>
        <van-pagination v-model="flowQuery.page" :page-count="flowTotalCount" mode="simple" @change="changeFlowPage" />
      </div>
    </van-popup>

    <van-popup position="top" closeable v-model="rechargeShow">
      <h4 class="title">{{ $t('user.rechargeTip') }}</h4>
      <p class="recharge-info">{{ $t('user.rechargeBank') }}</p>
      <p class="recharge-info">{{ $t('user.rechargeBankAccount') }}</p>
      <p class="recharge-info">{{ $t('user.rechargeCCI') }}</p>
      <p class="recharge-info">{{ $t('user.rechargeCompanyName') }}</p>
      <p class="recharge-info">{{ $t('user.rechargeUploadDes') }}</p>
      <div class="recharge-info">
        <van-uploader v-model="recharge.billList" :max-count="1" :before-read="beforeReadBill" :after-read="afterReadBill" />
      </div>
      <van-field v-model="recharge.amount" type="number" :label="$t('user.rechargeAmount')" class="popup-field" />
      <van-field v-model="recharge.remark" :label="$t('common.remark')" class="popup-field" />
      <van-button v-if="!recharge.success" type="primary" :loading="recharge.submiting" block @click="confirmRecharge">{{ $t('common.confirm') }}</van-button>
      <p v-else class="recharge-success-tip">{{ $t('user.rechargeSubmitedTip') }}</p>
    </van-popup>

    <van-popup position="top" closeable v-model="changePasswordShow">
      <h4 class="title">{{ $t('account.changePassword') }}</h4>
      <van-field type="password" v-model="changePassword.oldPassword" :label="$t('account.oldPassword')" class="popup-field" />
      <van-field type="password" v-model="changePassword.newPassword" :label="$t('account.newPassword')" class="popup-field" />
      <van-field type="password" v-model="changePassword.rePassword" :label="$t('account.confirmPassword')" class="popup-field" />
      <van-button type="primary" block @click="confirmChangePassword">{{ $t('common.confirm') }}</van-button>
    </van-popup>
  </div>
</template>

<script>
import i18n from '@/i18n'
import { compressImg } from '@/util/image'
import { Toast, Dialog } from 'vant'
import axios from 'axios'
import { getToken, getUserId, removeToken } from '@/util/auth'
import { getAccountInfo, getAccountFlow, rechargeApply } from '@/api/capital'
import { changePassword } from '@/api/account'

export default {
  data() {
    return {
      accountBalance: 0,
      applyedRechargeAmount: '',
      flowShow: false,
      flowItems: [],
      flowQuery: {
        page: 1
      },
      flowTotalCount: 0,
      rechargeShow: false,
      recharge: {
        des: i18n.t('common.submit'),
        billList: [],
        uploadedBillUrl: '',
        amount: '',
        remark: '',
        success: false,
        submiting: false,
      },
      changePasswordShow: false,
      changePassword: {
        oldPassword: '',
        newPassword: '',
        rePassword: ''
      }
    }
  },
  created() {
    this.fetchAccountAmount()
  },
  methods: {
    fetchAccountAmount() {
      getAccountInfo().then(rep => {
        this.accountBalance = rep.data.accountAmount
        this.applyedRechargeAmount = rep.data.applyedRechargeAmount
        if (this.applyedRechargeAmount > 0) {
          this.recharge.deses = 'S/. ' + this.applyedRechargeAmount + ' ' + i18n.t('user.processing')
        } else {
          this.recharge.deses = i18n.t('common.submit')
        }
      })
    },
    call() {
      window.open('tel://51969388325')
    },
    openWhatsapp() {
      window.open('https://api.whatsapp.com/send?phone=51969388325')
    },
    fetchFlow() {
      getAccountFlow(this.flowQuery).then(rep => {
        this.flowItems = rep.data.flow
        this.flowTotalCount = rep.data.totalCount
      })
    },
    showFlow() {
      this.fetchFlow()
      this.flowShow = true
    },
    changeFlowPage() {
      this.fetchFlow()
    },
    showRecharge() {
      if (!(this.applyedRechargeAmount > 0)) {
        this.rechargeShow = true
      }
    },
    beforeReadBill(file) {
      Toast.success(i18n.t('common.startUpload'))
      return compressImg(file)
    },
    afterReadBill(file) {
      const forms = new FormData()
      forms.append("rechargeBill", file.file)
      axios.post(process.env.VUE_APP_BASE_API + 'tools/uploadRechargeBill', forms, {
        headers: {
          "content-type": "multipart/form-data",
          'X-SP-Key': process.env.VUE_APP_API_KEY,
          'X-SP-Token': getToken(),
          'X-SP-UserId': getUserId()
        }
      }).then(rep => {
        if (rep.data.code == 1000) {
          this.recharge.uploadedBillUrl = rep.data.data
          Toast.success(i18n.t('common.uploadSuccess'))
        } else {
          Toast.fail(rep.data.msg)
        }
      })
    },
    confirmRecharge() {
      if (!this.recharge.uploadedBillUrl) {
        Toast.fail(i18n.t('user.rechargeUploadTip'))
      } else if (!(this.recharge.amount > 0)) {
        Toast.fail(i18n.t('user.rechargeAmountTip'))
      } else {
        this.recharge.submiting = true
        rechargeApply({
          amount: this.recharge.amount,
          billImg: this.recharge.uploadedBillUrl,
          remark: this.recharge.remark
        }).then(rep => {
          this.recharge.submiting = false
          if (rep.code == 1000) {
            this.recharge.success = true
            this.fetchAccountAmount()
          }
        }).catch(() => {})
      }
    },
    showChangePassword() {
      this.changePassword.oldPassword = ''
      this.changePassword.newPassword = ''
      this.changePassword.rePassword = ''
      this.changePasswordShow = true
    },
    confirmChangePassword() {
      if (!this.changePassword.oldPassword || !this.changePassword.newPassword || !this.changePassword.rePassword) {
        Toast.fail(i18n.t('account.fillPasswordTip'))
      } else if (this.changePassword.newPassword != this.changePassword.rePassword) {
        Toast.fail(i18n.t('account.confirmPasswordWrong'))
      } else {
        changePassword({ oldPassword: this.changePassword.oldPassword, newPassword: this.changePassword.newPassword }).then(rep => {
          Dialog.alert({
            title: i18n.t('common.editSuccess'),
            message: i18n.t('account.reLoginTip')
          }).then(() => {
            this.logout()
          })
        }).catch(() => {})
      }
    },
    logout() {
      removeToken()
      this.$router.push('/account/login')
    }
  }
}
</script>

<style scoped>
.title {
  text-align: center;
}
.flow-remark {
  padding-left:16px;
  padding-right: 16px;
  padding-bottom: 10px;
  color: #969799;
  font-size: 12px;
}
.recharge-info {
  font-size: 14px;
  text-align: center;
  margin: 1px 0;
  padding: 0 2rem;
}
.van-cell {
  padding-bottom: 0;
}
.van-cell::after {
  padding-bottom: 0px;
  border-bottom: 0;
}
.popup-field {
  border-bottom:1px solid #ebedf0;
}
.recharge-success-tip {
  color: #EE0A24;
  margin: 5px 0;
  padding: 0 2rem;
}
.bottom-btn {
  margin-top: 10px;
}
</style>